import { createSlice } from '@reduxjs/toolkit';

import { STATUS } from '../../../config/constants';

const initialState = {
  status: STATUS.NONE,
};

export const deleteCommentsSlice = createSlice({
  name: 'deleteComments',
  initialState,
  reducers: {
    resetState: (state) => {
      state.status = STATUS.NONE;
    },
    readyForNextState: (state) => {
      state.status = STATUS.NONE;
    },
    request: (state) => {
      state.status = STATUS.FETCHING;
    },
    success: (state) => {
      state.status = STATUS.SUCCESS;
    },
    failure: (state, action) => {
      const { payload: error } = action;
      state.status = STATUS.FAILURE;
      state.error = error;
    },
  },
});

export const { resetState, readyForNextState, request, success, failure } =
  deleteCommentsSlice.actions;

export const status = (state) => state.deleteComments.status;

export const error = (state) => state.deleteComments.error;

export default deleteCommentsSlice.reducer;
